export default {
  methods: {
    isDistanceValidated () {
      return this.$storage.get('distance_validated', 'no') === 'yes'
    }
  }
}
